import { logoVariant, type LogoVariantProps } from "./logo.variants";

export type UseLogoProps = LogoVariantProps & {
  className?: string;
  style?: Record<string, string | number>;
};

export const useLogo = (props: UseLogoProps) => {
  const { className = "", variant, ...componentProps } = props;

  const styles = logoVariant({
    variant,
  });

  return {
    className,
    styles,
    componentProps,
  };
};
